import Settings from '../domain/Settings';
import * as storage from '../utils/storage';
import {onIdentityUpdate} from './userService';
import {hasPurposesConsent, hasVendorsConsent} from './privacyService';

type CxenseProperties = {
	id?: string
	expiration?: string
};

const CXENSE_STORAGE_KEY = 'advert-cxense',
	CXENSE_VENDOR_IDS = [412],
	CXENSE_CONSENT_PURPOSES = [3, 4];

export function init() {
	if (!Settings.getInstance().features?.cxense) {
		return;
	}

	// Technically already covered through loading the library,
	// but we make sure as there have been issues in the past where the library was loaded without consent
	if (!hasPurposesConsent(CXENSE_CONSENT_PURPOSES) || !hasVendorsConsent(CXENSE_VENDOR_IDS)) {
		return;
	}

	const storedCxenseId = getCxenseProperties();

	if (!storedCxenseId?.expiration || new Date(storedCxenseId.expiration) <= new Date()) {
		window.cX = window.cX || {};
		window.cX.callQueue = window.cX.callQueue || [];

		if (Settings.getInstance().cxense?.includeLibrary) {
			_initializeLibrary();
		}

		_storeCxenseId();

		if (Settings.getInstance().cxense?.pageViewEvent) {
			_sendPageViewEvent();
		}
	}
}

function _initializeLibrary() {
	window.cX.options = {consent: true};
	window.cX.callQueue.push(['setConsent', {pv: true}]);
}

function _storeCxenseId() {
	if (!hasPurposesConsent([1])) {
		return;
	}

	window.cX.callQueue.push(['invoke', () => {
		const updatedCxenseId = window.cX.getCxenseUserId();

		if (updatedCxenseId) {
			_setIdInLocalStorage(updatedCxenseId);

			// noinspection JSIgnoredPromiseFromCall We don't care about the result
			onIdentityUpdate();
		}
	}]);
}

function _getExpirationDate() {
	const currDate = new Date();

	currDate.setDate(currDate.getDate() + 1);

	return currDate.toISOString();
}

function _setIdInLocalStorage(id: string) {
	if (!hasPurposesConsent([1])) {
		return;
	}

	storage.put(CXENSE_STORAGE_KEY, JSON.stringify({
		id,
		expiration: _getExpirationDate()
	}));
}

function _sendPageViewEvent() {
	window.cX.callQueue.push(['setEventAttributes', {
		origin: 'dpn-retargeting-Pixel',
		persistedQueryId: '362a54f75d61844e7d6387fed23f72322e15750d'
	}]);
	window.cX.callQueue.push(['setSiteId', '1353733223743909146']);
	window.cX.callQueue.push(['sendPageViewEvent']);
}

export function getCxenseProperties(): CxenseProperties | null {
	const storageValue = storage.get(CXENSE_STORAGE_KEY);

	if (!storageValue) {
		return null;
	}

	try {
		return JSON.parse(storageValue);
	} catch {
		return null;
	}
}
